<template>
    <div id="parent-information">
        <v-card-subtitle class="font-weight-bold pb-0">
            <v-icon :color="subAppColor" left>mdi-account</v-icon> Parent Profile
        </v-card-subtitle>
        <v-card-text>
            <v-container fluid>
                <v-row>
                    <v-col cols="12" md="4">
                        <v-text-field v-model="item.parentGuardianEmergencyContact.title" readonly hide-details
                            label="Title" placeholder="Not available">
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" md="8">
                        <v-text-field v-model="item.parentGuardianEmergencyContact.fullName" readonly hide-details
                            label="Full Name" placeholder="Not available">
                        </v-text-field>
                    </v-col>
                    <v-col cols="12">
                        <v-text-field v-model="item.parentGuardianEmergencyContact.relationship" readonly hide-details
                            label="Relationship" placeholder="Not available">
                        </v-text-field>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
        <v-card-subtitle class="font-weight-bold pb-0">
            <v-icon :color="subAppColor" left>mdi-home</v-icon> Address Information
        </v-card-subtitle>
        <v-card-text>
            <v-container fluid>
                <v-row>
                    <v-col cols="12" md="8">
                        <v-text-field v-model="item.parentGuardianEmergencyContact.address" readonly hide-details
                            label="Home Address" placeholder="Not available">
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-text-field v-model="item.parentGuardianEmergencyContact.postalCode" readonly hide-details
                            label="Postal Code" placeholder="Not available">
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-text-field v-model="item.parentGuardianEmergencyContact.country" readonly hide-details
                            label="Country" placeholder="Not available">
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-text-field v-model="item.parentGuardianEmergencyContact.city" readonly hide-details
                            label="City" placeholder="Not available">
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-text-field v-model="item.parentGuardianEmergencyContact.province" readonly hide-details
                            label="Province" placeholder="Not available">
                        </v-text-field>
                    </v-col>
                    <v-col v-if="item.parentGuardianEmergencyContact.province == 'Other'" cols="12">
                        <v-text-field v-model="item.parentGuardianEmergencyContact.provinceOther" readonly hide-details
                            label="Province (Other)" placeholder="Not available">
                        </v-text-field>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
        <v-card-subtitle class="font-weight-bold pt-5 pb-0">
            <v-icon :color="subAppColor" left>mdi-account-box</v-icon> Contact Information
        </v-card-subtitle>
        <v-card-text>
            <v-container fluid>
                <v-row>
                    <v-col cols="12" md="6">
                        <v-text-field v-model="item.parentGuardianEmergencyContact.homePhone" readonly hide-details
                            label="Home Phone" placeholder="Not available">
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-text-field v-model="item.parentGuardianEmergencyContact.cellPhone" readonly hide-details
                            label="Cell Phone" placeholder="Not available">
                        </v-text-field>
                    </v-col>
                    <v-col cols="12">
                        <v-text-field v-model="item.parentGuardianEmergencyContact.email" label="Email" readonly
                            hide-details placeholder="Not available">
                        </v-text-field>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
    </div>
</template>

<script>
export default {
    name: 'applicant-parent-information',
    props: {
        item: {
            required: true,
            type: Object
        }
    },
    computed: {
        subAppColor() {
            return '#FFA800';
        }
    }
}
</script>